import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/oroi-epikoinonias" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
